import { useState } from "react"

export const useKeyValueFormHandling = () => {

    const [formData, setFormData] = useState({
        categoryId: "",
        categoryName: "",
        keyName : "",
        sortOrder: "",
        parentKeyId: "",
        active: true,
        keyNameStatus: "",
    });  

    const handleChange = (event,selectEvent) => {
        
        let formState ={...formData};

         if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "parentKeyId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        } else if(event && event.target){
            switch(event.target.name){
                case "keyName": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,240})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (formData.keyNameStatus === "success") 
            {
                allowSubmit = true;
            } 
        else {
            allowSubmit = false;
        }

        return allowSubmit;
    };


    return{
        formData,
        setFormData,
        handleChange,
        checkAllFields
    }
}